/* ============================================================
   MORNING STAR — Shopify Theme JS (ported to Tinker/Horizon)
   ------------------------------------------------------------
   Guarded so it is safe even if several Morning Star sections
   each load this file — it only wires everything up once.
   ============================================================ */
(function () {
  if (window.__msMorningStarInit) return;
  window.__msMorningStarInit = true;

  function boot() {
    document.documentElement.classList.add('ms-anim-ready');
    initHeader();
    initMobileMenu();
    initReveal();
    initSectionAnims();
    init360Views();
    initAddToCart();
    initShareButtons();
    waitForGSAP();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-scan when a section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initSectionAnims();
    init360Views();
    initAddToCart();
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') initGSAP();
  });

/* ----------------------------------------------------------
   HEADER — scroll glass effect
   ---------------------------------------------------------- */
function initHeader() {
  var header = document.querySelector('.ms-header');
  if (!header) return;

  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 60);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ----------------------------------------------------------
   MOBILE MENU
   ---------------------------------------------------------- */
function initMobileMenu() {
  var hamburger = document.querySelector('.ms-header__hamburger');
  var menu      = document.querySelector('.ms-mobile-menu');
  if (!hamburger || !menu) return;

  var isOpen = false;

  function open() {
    isOpen = true;
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.innerHTML = iconX();
  }

  function close() {
    isOpen = false;
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.innerHTML = iconBars();
  }

  hamburger.addEventListener('click', function () { isOpen ? close() : open(); });

  menu.querySelectorAll('a, button').forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });
}

/* ----------------------------------------------------------
   SCROLL REVEAL — intentionally disabled.
   The old GSAP ScrollTrigger reveal left whole sections stuck at
   opacity:0 inside Shopify. Content is now visible by default
   (see morningstar.css). These stay as no-ops so other callers
   (shopify:section:load) don't error, and so a subtle entrance
   can be switched back on later without touching call sites.
   ---------------------------------------------------------- */
function initReveal() {
  markVisible('.ms-reveal, .ms-reveal-left, .ms-reveal-right');
}

function initSectionAnims() {
  markVisible('.gsap-heading, .gsap-slide-left, .gsap-slide-right, .gsap-card, .gsap-review-cards .ms-review-card');
}

function markVisible(selector) {
  document.querySelectorAll(selector).forEach(function (el) {
    el.classList.add('ms-revealed', 'ms-inview');
  });
}

/* ----------------------------------------------------------
   GSAP ANIMATIONS — loaded asynchronously
   ---------------------------------------------------------- */
function waitForGSAP() {
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    initGSAP();
  } else {
    window.addEventListener('load', function () {
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
          clearInterval(t);
          initGSAP();
        } else if (tries > 20) {
          clearInterval(t);
        }
      }, 200);
    });
  }
}

function initGSAP() {
  if (window.__msGsapInit) return;
  window.__msGsapInit = true;

  gsap.registerPlugin(ScrollTrigger);

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* Hero background parallax only — nothing here hides content. */
  var heroBg = document.querySelector('.ms-hero__bg');
  if (heroBg) {
    gsap.to(heroBg, {
      yPercent: 20,
      ease: 'none',
      scrollTrigger: { trigger: heroBg, start: 'top top', end: 'bottom top', scrub: true },
    });
  }

  /* Everything else (headings, cards, slide-ins) is handled by
     initSectionAnims() via IntersectionObserver — ScrollTrigger is
     unreliable inside Shopify. */
}

/* ----------------------------------------------------------
   360° PRODUCT VIEW
   ---------------------------------------------------------- */
/* ----------------------------------------------------------
   SHARE — native share sheet where available, else copy-link
   ---------------------------------------------------------- */
function initShareButtons() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ms-share__native');
    if (!btn) return;

    var url = btn.dataset.shareUrl || window.location.href;
    var title = btn.dataset.shareTitle || document.title;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {
        /* user cancelled the native share sheet — nothing to do */
      });
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        msShowShareCopiedHint(btn);
      });
    }
  });
}

function msShowShareCopiedHint(btn) {
  var previousLabel = btn.getAttribute('aria-label');
  btn.setAttribute('aria-label', 'Link copied');
  btn.classList.add('ms-share__btn--copied');
  window.setTimeout(function () {
    btn.setAttribute('aria-label', previousLabel);
    btn.classList.remove('ms-share__btn--copied');
  }, 1800);
}

function init360Views() {
  document.querySelectorAll('.ms-product-view').forEach(function (viewEl) {
    if (viewEl.dataset.msBound === '1') return;
    var imgWrap = viewEl.querySelector('.ms-product-view__img-wrap');
    var img     = imgWrap && imgWrap.querySelector('.ms-product-view__img');
    var btn     = viewEl.querySelector('.ms-360-btn');
    var hint    = viewEl.querySelector('.ms-360-hint');
    if (!imgWrap || !img || !btn) return;
    viewEl.dataset.msBound = '1';

    var active    = false;
    var dragging  = false;
    var rotation  = 0;
    var lastX     = 0;
    var raf       = null;

    function spin() {
      rotation = (rotation + 0.4) % 360;
      img.style.transform = 'rotateY(' + rotation + 'deg)';
      if (active && !dragging) raf = requestAnimationFrame(spin);
    }

    btn.addEventListener('click', function () {
      active = !active;
      rotation = 0;
      if (active) {
        imgWrap.style.cursor = 'grab';
        imgWrap.classList.add('is-360-active');
        btn.classList.add('is-active');
        btn.innerHTML = svgRefresh() + 'Exit 360°';
        if (hint) hint.style.display = 'block';
        raf = requestAnimationFrame(spin);
      } else {
        cancelAnimationFrame(raf);
        imgWrap.style.cursor = '';
        imgWrap.classList.remove('is-360-active');
        btn.classList.remove('is-active');
        btn.innerHTML = svgRefresh() + '360° View';
        if (hint) hint.style.display = 'none';
        img.style.transition = 'transform 0.6s ease';
        img.style.transform = 'rotateY(0deg)';
        setTimeout(function () { img.style.transition = ''; }, 650);
      }
    });

    /* Mouse */
    imgWrap.addEventListener('mousedown', function (e) {
      if (!active) return;
      dragging = true; lastX = e.clientX;
      imgWrap.style.cursor = 'grabbing';
      cancelAnimationFrame(raf);
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging || !active) return;
      var delta = e.clientX - lastX;
      rotation = ((rotation + delta * 0.5) % 360 + 360) % 360;
      img.style.transform = 'rotateY(' + rotation + 'deg)';
      lastX = e.clientX;
    });
    window.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      if (active) { imgWrap.style.cursor = 'grab'; raf = requestAnimationFrame(spin); }
    });

    /* Touch */
    imgWrap.addEventListener('touchstart', function (e) {
      if (!active) return;
      dragging = true; lastX = e.touches[0].clientX;
      cancelAnimationFrame(raf);
    }, { passive: true });
    imgWrap.addEventListener('touchmove', function (e) {
      if (!dragging || !active) return;
      var delta = e.touches[0].clientX - lastX;
      rotation = ((rotation + delta * 0.5) % 360 + 360) % 360;
      img.style.transform = 'rotateY(' + rotation + 'deg)';
      lastX = e.touches[0].clientX;
    }, { passive: true });
    imgWrap.addEventListener('touchend', function () {
      dragging = false;
      if (active) raf = requestAnimationFrame(spin);
    });
  });
}

/* ----------------------------------------------------------
   ADD TO CART — Shopify AJAX API
   ---------------------------------------------------------- */
function initAddToCart() {
  document.querySelectorAll('.ms-product-add-btn').forEach(function (btn) {
    if (btn.dataset.msBound === '1' || !btn.dataset.variantId) return;
    btn.dataset.msBound = '1';
    btn.addEventListener('click', function () { msAddToCart(btn); });
  });
}

/* Reads the current header cart count (bubble, then Horizon's sessionStorage). */
function msReadCartCount() {
  var el = document.querySelector('.cart-bubble__count, [data-cart-count], .ms-header__cart-count');
  var n = el ? parseInt((el.textContent || '').trim(), 10) : NaN;
  if (!isNaN(n)) return n;
  try {
    var st = JSON.parse(sessionStorage.getItem('cart-count') || 'null');
    if (st && !isNaN(parseInt(st.value, 10))) return parseInt(st.value, 10);
  } catch (e) {}
  return 0;
}

function msWriteCartCount(n) {
  try {
    sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() }));
  } catch (e) {}
  document.querySelectorAll('.cart-bubble__count, [data-cart-count], .ms-header__cart-count').forEach(function (el) {
    el.textContent = n < 100 ? String(n) : '';
  });
}

function msAddToCart(btn) {
  var variantId = parseInt(btn.dataset.variantId, 10);
  if (!variantId || btn.dataset.msBusy === '1') return;
  btn.dataset.msBusy = '1';

  var original = btn.dataset.msLabel || btn.innerHTML;
  btn.dataset.msLabel = original;
  btn.disabled = true;
  btn.innerHTML = svgSpinner() + 'Adding...';

  /* Ask Shopify to also return fresh HTML for Horizon's cart sections so the
     drawer/mini-cart update instantly instead of after a second round-trip. */
  var sectionIds = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
    if (sectionIds.indexOf(c.dataset.sectionId) === -1) sectionIds.push(c.dataset.sectionId);
  });

  var body = { items: [{ id: variantId, quantity: 1 }] };
  if (sectionIds.length) {
    body.sections = sectionIds.join(',');
    body.sections_url = window.location.pathname;
  }

  var done = function () {
    btn.classList.remove('is-added');
    btn.innerHTML = original;
    btn.disabled = false;
    btn.dataset.msBusy = '';
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  })
    .then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    })
    .then(function (res) {
      if (!res.ok || res.data.status) {
        throw new Error(res.data.description || res.data.message || 'Add to cart failed');
      }

      /* Instant button feedback — no second fetch in the way. */
      btn.classList.add('is-added');
      btn.innerHTML = svgCheck() + 'Added!';

      /* Optimistic count, then hand off to Horizon's own cart components. */
      var newCount = msReadCartCount() + 1;
      msWriteCartCount(newCount);

      var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true, composed: true });
      ev.action = 'add';
      ev.promise = Promise.resolve({
        cart: { totalQuantity: newCount },
        detail: { itemCount: newCount, source: 'morningstar', sections: res.data.sections, didError: false },
      });
      document.dispatchEvent(ev);

      /* Reconcile the exact count in the background. */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { msWriteCartCount(cart.item_count); })
        .catch(function () {});

      setTimeout(done, 1400);
    })
    .catch(function (err) {
      console.error('[MS] Add to cart error:', err);
      done();
    });
}

/* ----------------------------------------------------------
   INLINE SVG HELPERS
   ---------------------------------------------------------- */
function svgRefresh() {
  return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:5px"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>';
}
function svgCheck() {
  return '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:5px"><polyline points="20 6 9 17 4 12"/></svg>';
}
function svgSpinner() {
  return '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:5px;animation:ms-spin 0.9s linear infinite"><path d="M21 12a9 9 0 1 1-6.22-8.56"/></svg>';
}
function iconBars() {
  return '<svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" viewBox="0 0 24 24"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
}
function iconX() {
  return '<svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
}
})();